
import axios from "axios";
import qs from "qs";
import {
  isTokenExpired,
  getAccessToken,
  getRefreshToken,
  setAccessToken,
  removeTokens,
  getCredentials,
  updateLastActive,
  refreshTokenIfExpiringSoon
} from "./auth";
import { API_URL } from "../constants/data";

const api = axios.create();

const performBackgroundLogin = async () => {
  try {
    const refreshToken = getRefreshToken();
    const response = await axios.post(`${API_URL}/refresh`,
      { refresh_token: refreshToken },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        withCredentials: true
      }
    );

    if (response.status === 200 && response.data.access_token) {
      return response.data.access_token;
    }
  } catch (error) {
    console.error("Token refresh failed:", error);
  }
  return null;
};

api.interceptors.request.use(
  async (config) => {
    updateLastActive(); // Keep tracking activity

    // Proactive refresh if token is close to expiry
    await refreshTokenIfExpiringSoon();

    let token = getAccessToken();

    // If token is missing or expired, try to refresh immediately
    if (!token || isTokenExpired(token)) {
      const newToken = await performBackgroundLogin();
      if (newToken) {
        setAccessToken(newToken);
        token = newToken;
      } else {
        removeTokens();
        window.location.href = "/doca_pgr";
        return Promise.reject("Session expired");
      }
    }

    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle 401s (e.g. if token expired during request)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If error is 401 and we haven't retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const newToken = await performBackgroundLogin();
        if (newToken) {
          setAccessToken(newToken);
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        console.error("Refresh failed during retry:", refreshError);
      }

      // If refresh failed, logout
      removeTokens();
      window.location.href = "/doca_pgr";
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);


export default api;
